class Iphone18VideoShowcase extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.control = this.querySelector('[data-video-control]');
    if (!this.video || !this.control) return;

    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.isIntersecting = false;
    this.isManuallyPaused = this.motionQuery.matches;

    this.handleControlClick = this.handleControlClick.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleMotionChange = this.handleMotionChange.bind(this);
    this.handlePlay = () => this.updatePlaybackState(true);
    this.handlePause = () => this.updatePlaybackState(false);

    this.control.addEventListener('click', this.handleControlClick);
    this.video.addEventListener('play', this.handlePlay);
    this.video.addEventListener('pause', this.handlePause);
    this.video.addEventListener('ended', this.handlePause);
    this.video.addEventListener('error', this.handlePause);
    this.motionQuery.addEventListener('change', this.handleMotionChange);

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0.25 });
      this.observer.observe(this);
    } else {
      this.isIntersecting = true;
      this.syncPlayback();
    }
  }

  handleControlClick() {
    if (this.video.paused) {
      this.isManuallyPaused = false;
      this.playVideo();
      return;
    }

    this.isManuallyPaused = true;
    this.video.pause();
  }

  handleIntersection(entries) {
    const entry = entries.find(({ target }) => target === this);
    if (!entry) return;

    this.isIntersecting = entry.isIntersecting;
    this.syncPlayback();
  }

  handleMotionChange(event) {
    this.isManuallyPaused = event.matches;
    this.syncPlayback();
  }

  syncPlayback() {
    if (!this.isIntersecting || this.isManuallyPaused || this.motionQuery.matches) {
      this.video.pause();
      return;
    }

    this.playVideo();
  }

  playVideo() {
    this.video.play().catch(() => this.updatePlaybackState(false));
  }

  updatePlaybackState(isPlaying) {
    const playLabel = this.control.dataset.playLabel;
    const pauseLabel = this.control.dataset.pauseLabel;
    this.classList.toggle('is-playing', isPlaying);
    this.control.setAttribute('aria-pressed', String(isPlaying));
    this.control.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.control?.removeEventListener('click', this.handleControlClick);
    this.video?.removeEventListener('play', this.handlePlay);
    this.video?.removeEventListener('pause', this.handlePause);
    this.video?.removeEventListener('ended', this.handlePause);
    this.video?.removeEventListener('error', this.handlePause);
    this.motionQuery?.removeEventListener('change', this.handleMotionChange);
    this.video?.pause();
  }
}

if (!customElements.get('iphone-18-video-showcase')) {
  customElements.define('iphone-18-video-showcase', Iphone18VideoShowcase);
}